var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88639 1.08197L0.152372 4.16374C-0.041096 4.28972 -0.0517475 4.50848 0.128543 4.65245L3.55065 7.38613L9.02953 4.01479L5.55768 1.12147C5.38029 0.973748 5.07986 0.9562 4.88639 1.08197Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.534 14.3392L9.05166 11.4562V11.4336L9.0406 11.4449L9.02954 11.4336V11.4562L5.5581 14.3386C5.3805 14.4861 5.08004 14.5032 4.88678 14.3771L3.60645 13.5407V14.3207C3.60645 14.5516 3.7669 14.8347 3.96498 14.9533C3.96498 14.9533 9.02971 17.9906 9.02971 17.9937C9.02971 17.9969 9.0322 17.9969 9.03534 17.9937C9.03848 17.9906 9.04326 17.9906 9.0464 17.9937C9.04954 17.9969 9.05207 17.9969 9.05207 17.9937C9.05207 17.9906 14.1277 14.9529 14.1277 14.9529C14.3258 14.8344 14.4864 14.5513 14.4864 14.3207V13.5407L13.2061 14.3771C13.0125 14.5032 12.7115 14.4863 12.534 14.3392Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.152342 10.6184L4.88616 13.7002C5.07963 13.8262 5.38009 13.8085 5.55748 13.6607L9.02953 10.7674L3.55086 7.38477L0.128308 10.1291C-0.0518121 10.2735 -0.0409216 10.4927 0.152342 10.6184Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9067 4.16354L13.1833 1.08242C12.9901 0.95624 12.6894 0.973583 12.512 1.12107L9.0293 4.0148L14.508 7.38614L17.9301 4.65245C18.1105 4.50852 18.1 4.28955 17.9067 4.16354Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.931 10.1291L14.5085 7.38477L9.38542 10.5478C9.18901 10.669 9.17378 10.8869 9.35138 11.0344L12.5126 13.6611C12.6901 13.8086 12.9906 13.8259 13.1839 13.6997L17.9072 10.6188C18.1005 10.4926 18.1112 10.2735 17.931 10.1291Z",
    fill: "#2A2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.c1d24f44.svg";
export { ForwardRef as ReactComponent };